import { StringData } from "../../core/StringData";

export class StringScrollbarVertical {
  private scrollbar: any;
  private thumb: any;
  private isDragging = false;
  private onScrollTo: (position: number) => void;
  private startCoordinate: number = 0;
  private startScrollPosition: number = 0;
  data: StringData;

  /**
   * @param data Shared scroll/viewport data.
   * @param scrollbar The scrollbar track element.
   * @param thumb The scrollbar thumb element.
   * @param onScrollTo Called on thumb drag with the target position in px.
   *   This maps directly to `ScrollController.scrollTo()` on the active adapter —
   *   custom adapters must implement `scrollTo()` to sync their internal state.
   */
  constructor(
    data: StringData,
    scrollbar: any,
    thumb: any,
    onScrollTo: (position: number) => void,
  ) {
    this.data = data;
    this.scrollbar = scrollbar;
    this.thumb = thumb;
    this.onScrollTo = onScrollTo;
  }

  onResize(): void {
    const contentSize = this.data.viewport.contentHeight;
    const visibleSize = this.data.viewport.windowHeight;
    const thumbSize = (visibleSize / contentSize) * visibleSize;
    this.thumb.style.setProperty('--height', thumbSize + 'px');
    if (contentSize <= visibleSize) {
      this.scrollbar.classList.add('-hide');
    } else {
      this.scrollbar.classList.remove('-hide');
    }
  }

  updateThumb() {
    const contentHeight = this.data.viewport.contentHeight;
    const visibleHeight = this.data.viewport.windowHeight;
    
    this.thumb.style.setProperty('--position', `${(this.data.scroll.current / contentHeight) * visibleHeight + 'px'}`);
  }

  mouseDownEvent(e: MouseEvent) {
    this.startCoordinate = e.clientY;
    this.startScrollPosition = this.data.scroll.current;
  }

  mouseMoveEvent(e: MouseEvent) {
    const deltaY = e.clientY - this.startCoordinate;
    const newScrollPosition = this.startScrollPosition + (deltaY / this.data.viewport.windowHeight) * this.data.viewport.contentHeight;
    const maxScroll = this.data.scroll.bottomPosition;
    const clamped = Math.max(0, Math.min(newScrollPosition, maxScroll));
    this.onScrollTo(clamped);
    this.updateThumb();
  }
}
